import { Component, OnInit } from '@angular/core';
import { Router }              from '@angular/router';

import { Step5 }            from '../data/formData.model';
import { FormDataService }     from '../data/formData.service';
import {FormControl, Validators} from '@angular/forms';

interface Gender {
  value: string;
}

interface Source {
  value: string;
  name: string;
}

@Component({
  selector: 'app-art-wohnung-step5',
  templateUrl: './art-wohnung-step5.component.html',
  styleUrls: ['./art-wohnung-step5.component.scss']
})
export class ArtWohnungStep5Component implements OnInit {

  title = 'Wer soll das unverbindlichen Angebot erhalten?';
  form: any;
  step5: Step5;
  checked = false;
   indeterminate = false;
   labelPosition = 'after';
   disabled = false;

  options: Gender[] = [
    { value : 'Herr'},
    { value : 'Frau'}
 ];

 options2: Source[] = [
  { name : 'Google-Suche', value: '1'},
  { name : 'Persönliche Empfehlung', value: '4'},
  { name : 'Zeitung', value: '5'},
  { name : 'TV / Radio', value: '6'},
  { name : 'Social Media', value: '7'},
  { name : 'Medienberichte', value: '8'},
  { name : 'Messe / Seminar', value: '9'},
  { name : 'Andere', value: '10'}
];
    

  constructor(private router: Router, private formDataService: FormDataService) {
  }

  ngOnInit() {
      this.step5 = this.formDataService.getStep5();
      console.log('Kontakt feature loaded!');
  }

  save(form: any): boolean {
        if (!form.valid) {
            return false;
        }
      this.formDataService.setStep5(this.step5);
      return true;
  }

  goToNext(form: any) {
      if (this.save(form)) {
        this.sendMessage('movetop');
        this.router.navigate(['/final']);
      }
  }

  goToPrevious(form: any) {
    this.sendMessage('movetop');
    this.router.navigate(['/wohnung-step4']);
  }

  // Send a message to the parent
  sendMessage(msg: string) {
    window.parent.postMessage(msg, '*');
   }

}
